export const rawDateInputDirections = {
  Down: 'down',
  Default: 'default',
} as const;
